import { getDatasetAccessList } from "admin/rest_api";
import { Spin, Tag } from "antd";
import { stringToTagColor } from "libs/colors";
import { handleGenericError } from "libs/error_handling";
import { useFetch } from "libs/react_helpers";
import type React from "react";
import { useState } from "react";
import type { APIDataset, APIUser } from "types/api_types";

type Props = {
  dataset: APIDataset;
};

const DatasetAccessListView = ({ dataset }: Props) => {
  const [isLoading, setIsLoading] = useState(false);

  const datasetUsers = useFetch(
    () => {
      try {
        setIsLoading(true);
        return getDatasetAccessList(dataset);
      } catch (error) {
        handleGenericError(error as Error);
        return Promise.resolve([]);
      } finally {
        setIsLoading(false);
      }
    },
    [],
    [],
  );

  function renderUserTags(user: APIUser): React.ReactNode[] {
    if (user.isAdmin) {
      return [
        <Tag key={`team_role_${user.id}`} color="red">
          Admin
        </Tag>,
      ];
    } else {
      const managerTags = user.isDatasetManager
        ? [
            <Tag key={`dataset_manager_${user.id}`} color="geekblue">
              Dataset Manager
            </Tag>,
          ]
        : [];
      const teamTags = user.teams.map((team) => (
        <Tag color={stringToTagColor(team.name)} key={`${user.id}-${team.id}`}>
          {team.name}
        </Tag>
      ));
      return managerTags.concat(teamTags);
    }
  }

  function renderTable() {
    return (
      <div>
        <ul>
          {datasetUsers.map((user: APIUser) => (
            <li key={user.id}>
              <div
                style={{
                  width: 150,
                  display: "inline-block",
                }}
              >
                {user.firstName} {user.lastName}
              </div>
              {renderUserTags(user)}
            </li>
          ))}
        </ul>
      </div>
    );
  }

  return (
    <Spin size="large" spinning={isLoading}>
      {renderTable()}
    </Spin>
  );
};

export default DatasetAccessListView;
